// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-manage-container {
  padding: 20px;
  background: #f4f6f9;
  min-height: 20vh;
}

.form-title {
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 18px;
  color: #1f2d3d;
}

/* GRID */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 14px;
  margin-bottom: 25px;
}

/* CARD */
.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px;
  text-align: center;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid transparent;
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

/* ACTIVE */
.info-card.active {
  transform: scale(1.03);
  border-color: #2d6cdf;
}

/* ICON */
.info-icon {
  font-size: 26px;
  margin-bottom: 8px;
  color: #2d6cdf;
}

/* LABEL */
.info-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

/* OUTPUT */
.info-output {
  margin-top: 10px;
  background: #fff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

/* COLOR BORDERS */
.add { border-top: 3px solid #4caf50; }
.list { border-top: 3px solid #2196f3; }
.cred { border-top: 3px solid #ff9800; }
.visitor { border-top: 3px solid #9c27b0; }

/* RESPONSIVE */
@media (max-width: 600px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InfoManage/InfoManage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB,OAAO,6BAA6B,EAAE;AACtC,QAAQ,6BAA6B,EAAE;AACvC,QAAQ,6BAA6B,EAAE;AACvC,WAAW,6BAA6B,EAAE;;AAE1C,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".info-manage-container {\n  padding: 20px;\n  background: #f4f6f9;\n  min-height: 20vh;\n}\n\n.form-title {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 18px;\n  color: #1f2d3d;\n}\n\n/* GRID */\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 14px;\n  margin-bottom: 25px;\n}\n\n/* CARD */\n.info-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 18px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid transparent;\n}\n\n.info-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\n}\n\n/* ACTIVE */\n.info-card.active {\n  transform: scale(1.03);\n  border-color: #2d6cdf;\n}\n\n/* ICON */\n.info-icon {\n  font-size: 26px;\n  margin-bottom: 8px;\n  color: #2d6cdf;\n}\n\n/* LABEL */\n.info-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* OUTPUT */\n.info-output {\n  margin-top: 10px;\n  background: #fff;\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n/* COLOR BORDERS */\n.add { border-top: 3px solid #4caf50; }\n.list { border-top: 3px solid #2196f3; }\n.cred { border-top: 3px solid #ff9800; }\n.visitor { border-top: 3px solid #9c27b0; }\n\n/* RESPONSIVE */\n@media (max-width: 600px) {\n  .info-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
